namespace Matrix.Rebalancer {
    export class SessionColumns {
        static columnsKey = 'Rebalancer.Session';
    }
}
